/**
 * Wraps `action` so a burst of calls runs it once, `delayMs` after the first.
 *
 * Trailing edge with no leading call. Written for the legacy map events, which arrive one per changed
 * device — every consumer wants the burst, not each event.
 */
export type Coalesced = (() => void) & { cancel: () => void };

export const coalesce = (action: () => void, delayMs: number): Coalesced => {
    let pending: ReturnType<typeof setTimeout> | null = null;

    const run = (() => {
        if (pending) return;
        pending = setTimeout(() => {
            pending = null;
            action();
        }, delayMs);
    }) as Coalesced;

    run.cancel = () => {
        if (!pending) return;
        clearTimeout(pending);
        pending = null;
    };

    return run;
};
